module.exports = __webpack_public_path__ + "static/media/thanks.cd2d943d.png";